const React = require('react');
const { StoreProvider } = require('./src/context/StoreContext');
const ShopifyConsent = require('./src/components/ShopifyConsent').default;
const { trackShopifyPageView } = require('./src/utils/ShopifyAnalytics');

exports.wrapRootElement = ({ element }) => (
  <ShopifyConsent>
    <StoreProvider>{element}</StoreProvider>
  </ShopifyConsent>
);

exports.onRouteUpdate = ({ location }) => {
  if (!window.dataLayer) window.dataLayer = [];

  window.dataLayer.push({
    event: 'gatsby-route-change',
    page_path: location.pathname + location.search + location.hash,
    page_location: window.location.href,
    page_title: document.title,
  });

  trackShopifyPageView();
};
